<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromPost" ref="fromPost" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('pgCommon.POST_CAPTION')">
                                    <td-input placeholder="common.PLEASE_INPUT" v-model="fromPost.postName"></td-input>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('pgCommon.POST_RANK')">
                                    <td-select v-model="fromPost.rank" :placeholder="$t('common.PLEASE_SELECT')" :options="this.rankList" keys="value" text="label" :clearable="false"> </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="btnClickQuery()">{{ $t('pgCommon.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddPost">{{ $t('pgCommon.ADD') }}</td-button>
                            <td-button size="medium" :permissions="permissionsDel" @click="batchDelete()">{{ $t('pgCommon.DELETE') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-permission :permissions="permissionsView" style="width:100%;">
                <div slot="havePermission">
                    <td-table
                        :columns="columns"
                        :dataSource="tableData"
                        :pageSize="pageSize"
                        :currentPage="currentPage"
                        :total="total"
                        :hasMutiSelect="true"
                        :stripe="true"
                        :highlightCurrentRow="true"
                        rowKey="sId"
                        ref="postTab"
                        :hasLoading="loading"
                        @row-click="rowClick"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                    ></td-table>
                </div>
            </td-permission>
            <dialog-PostInfo
                v-if="dialogPostVisible"
                :isAddData="isAddData"
                :dialogPostVisible="dialogPostVisible"
                :editItem="editItem"
                :title="title"
                ref="postInfo"
                @postDialogClose="postDialogClose"
                @btnQuery="btnQuery"
                @submit="submit"
                :orgTreeUrl="orgTreeUrl"
            ></dialog-PostInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogPostInfo from './components/dialogPostInfo.vue';
import resourceApi from './assets/api.js';
// import Sortable from 'sortablejs'
export default {
    // 初始化渲染
    components: {
        'dialog-PostInfo': dialogPostInfo
    },
    created() {
        this.getDictValuesByTag();
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        if (this.$util.isEmpty(this.fromPost.postName)) {
            this.isQueryByName = true;
        } else {
            this.isQueryByName = false;
        }
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['station:view'],
            permissionsAdd: ['station:add'],
            permissionsDel: ['station:del'],
            permissionsEdit: ['station:edit'],
            fromPost: {
                postName: '',
                rank: ''
            },
            editItem: '',
            dialogPostVisible: false,
            tableData: [],
            rankList: [
                {
                    value: '',
                    label: this.$t('pgCommon.ALL')
                }
            ],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            isQueryByName: false,
            selectRow: null,
            // 对表单进行数据验证
            rules: {
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'sName',
                    label: this.$t('pgCommon.POST_CAPTION')
                },
                {
                    prop: 'sStationType',
                    label: this.$t('pgCommon.POST_RANK'),
                    render: (createElement, params) => {
                        let res = params.row.sStationType;
                        let ret = '';
                        this.rankList.forEach(element => {
                            if (element.value == res && element.value != '') {
                                ret = element.label;
                            }
                        });
                        return createElement('div', ret);
                    }
                },
                {
                    prop: 'sDescription',
                    label: this.$t('pgCommon.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '250',
                    align: 'center',
                    render: (createElement, params) => {
                        // 编辑
                        let btnEdit = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.btnEditPost(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.EDIT')
                        );
                        // 删除
                        let btnDel = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.delelete([params.row.sId]);
                                    }
                                }
                            },
                            this.$t('pgCommon.DELETE')
                        );
                        // 上移
                        let btnMoveUp = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveUp(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_UP')
                        );
                        // 下移
                        let btnMoveDown = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveDown(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_DOWN')
                        );
                        // 置顶
                        let btnMoveTop = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickMoveTop(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.MOVE_TOP')
                        );
                        // 取消
                        let btnCancel = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickCancelTop(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.CANCEL')
                        );
                        let list = [];
                        // 如果是按名称查询，则隐藏上移下移
                        if (this.isQueryByName) {
                            if (params.row.iOrder < 10000) {
                                list = [btnEdit, btnDel, btnMoveUp, btnMoveDown, btnMoveTop, btnCancel];
                            } else {
                                list = [btnEdit, btnDel, btnMoveTop];
                            }
                        } else {
                            if (params.row.iOrder < 10000) {
                                list = [btnEdit, btnDel, btnMoveTop, btnCancel];
                            } else {
                                list = [btnEdit, btnDel, btnMoveTop];
                            }
                        }
                        return createElement('div', list);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 点击某一行
        rowClick(row, event, column) {
            this.selectRow = row;
        },

        // 查询
        btnClickQuery() {
            if (this.$util.isEmpty(this.fromPost.postName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            if (this.$util.isEmpty(this.fromPost.postName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            if (this.$util.isEmpty(this.fromPost.postName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        getDictValuesByTag() {
            let content = {
                sTag: 'RANK'
            };
            resourceApi.getDictValuesByTag(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('hostApi.getDictValuesByTag', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('hostApi.getDictValuesByTag', response.data.statusMessage);
                    return;
                }
                response.data.content.forEach(element => {
                    let param = {
                        value: element.sCode,
                        label: element.label
                    };
                    this.rankList.push(param);
                });
            });
        },

        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sName: this.fromPost.postName,
                sstationType: this.fromPost.rank,
                pageSize: this.pageSize,
                currentPage: this.currentPage,
                needPage: true
            };
            resourceApi.queryPortStation(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
                this.$refs.postTab.setCurrentRow(this.selectRow);
            });
        },
        // 添加
        btnAddPost() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogPostVisible = true;
        },
        // 编辑
        btnEditPost(row) {
            this.editItem = row;
            this.title = this.$t('pgCommon.EDIT');
            this.isAddData = false;
            this.dialogPostVisible = true;
        },
        // 批量删除
        batchDelete() {
            let rows = this.$refs.postTab.getSelectAllRows();
            let postIds = [];
            for (let i = 0; i < rows.length; i++) {
                const element = rows[i];
                postIds.push(element.sId);
            }
            if (postIds.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_STATION') });
                return;
            }
            this.delelete(postIds);
        },
        // 删除接口
        delelete(postIds) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.deletePortStation(JSON.stringify(postIds), response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('portStationManagerController/deletePortStation', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('roleInfo/btnDelete---- Fail')
                });
        },

        // 上移
        onClickMoveUp(row) {
            // 上一条数据的序号
            let perviousIndex = '';
            if (this.tableData != null && this.tableData.length > 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (row.sId === this.tableData[i].sId) {
                        perviousIndex = i - 1;
                        break;
                    }
                }
            }
            let perviousData = this.tableData[perviousIndex];
            if (!this.$util.isEmpty(perviousData)) {
                let param = {
                    sId: row.sId,
                    latterId: perviousData.sId
                };
                this.moveUpOrDown(param);
            } else {
                let param = {
                    sId: row.sId,
                    queryType: 1
                };
                resourceApi.queryPerviousOrLatter(JSON.stringify(param), response => {
                    this.loading = false;
                    if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                        this.$log.error('/device/queryPerviousOrLatter', response);
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        return;
                    }
                    if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('/device/queryPerviousOrLatter', response.data.statusMessage);
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        return;
                    }
                    if (this.$util.isEmpty(response.data.content)) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.TOP_NODE_CANNT_MOVEUP'), type: 'warning' });
                        return;
                    }
                    this.currentPage--;
                    let perviousItem = response.data.content;
                    let param = {
                        sId: row.sId,
                        previousId: perviousItem.sId
                    };
                    this.moveUpOrDown(param);
                });
            }
        },

        // 下移
        onClickMoveDown(row) {
            let latterIndex = null;
            // 取下一条数据
            if (this.tableData != null && this.tableData.length > 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (row.sId === this.tableData[i].sId) {
                        latterIndex = i + 1;
                        break;
                    }
                }
            }
            let latterData = this.tableData[latterIndex];
            if (!this.$util.isEmpty(latterData)) {
                if (latterData.iOrder == 10000) {
                    this.$message({ showClose: true, message: this.$t('pgMessage.ONLY_MOVE_TOP_CAN_OPERATE_CANNT_MOVE_DOWN'), type: 'warning' });
                    return;
                } else if (!this.$util.isEmpty(latterData) && latterData.iOrder < 10000) {
                    let param = {
                        sId: row.sId,
                        latterId: latterData.sId
                    };
                    this.moveUpOrDown(param);
                }
            } else {
                let param = {
                    sId: row.sId,
                    queryType: 2
                };
                resourceApi.queryPerviousOrLatter(JSON.stringify(param), response => {
                    this.loading = false;
                    if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                        this.$log.error('/device/queryPerviousOrLatter', response);
                        this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                        return;
                    }
                    if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('/device/queryPerviousOrLatter', response.data.statusMessage);
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        return;
                    }
                    if (this.$util.isEmpty(response.data.content)) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.LAST_ONE_CANNT_MOVE_DOWN'), type: 'warning' });
                        return;
                    }
                    let latterItem = response.data.content;
                    if (latterItem.iOrder == 10000) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.ONLY_MOVE_TOP_CAN_OPERATE_CANNT_MOVE_DOWN'), type: 'warning' });
                        return;
                    } else if (!this.$util.isEmpty(latterItem) && latterItem.iOrder < 10000) {
                        this.currentPage++;
                        let param = {
                            sId: row.sId,
                            latterId: latterItem.sId
                        };
                        this.moveUpOrDown(param);
                    }
                });
            }
        },

        // 上移或者下移
        moveUpOrDown(param) {
            resourceApi.moveUpOrDown(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/moveUpOrDown', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/moveUpOrDown', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 置顶
        onClickMoveTop(row) {
            let param = {
                sId: row.sId
            };
            resourceApi.moveToTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/onClickMoveTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/onClickMoveTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 取消置顶
        onClickCancelTop(row) {
            let param = {
                sId: row.sId
            };
            resourceApi.removeFromTop(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/removeFromTop', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/removeFromTop', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.btnQuery();
            });
        },

        // 组件关闭需要调用的方法
        submit() {
            if (this.$util.isEmpty(this.fromPost.postName)) {
                this.isQueryByName = true;
            } else {
                this.isQueryByName = false;
            }
            this.btnQuery();
        },

        // 关闭页面
        postDialogClose() {
            this.dialogPostVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
